import { BookingDTO } from "app/pages/Checkout/CheckoutModels";
import { AddOnAddDto } from "../../../interfaces/busines-item-response";
import api from "../../../services/api";
import { Category } from "../category/categoryService";

const checkoutServices = {
  getCheckoutSession(id: string, start_time?: string, end_time?: string) {
    return api.get(
      `/referral/${id}/checkout?${start_time ? "start_time=" + start_time + "&end_time=" + end_time : ""}`,
    );
  },
  getStripeToken(amount: number) {
    return api.get("/booking/token/" + amount);
  },
  createStripeSession(payload: CreateBookingLinkDto) {
    return api.post("/referals/createReferalLink", payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  async createFareharborStripeSession(payload: FareHarborBooking) {
    return await api.post("/booking/fareharbor", payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
  createCheckoutSession(payload: BookingDTO) {
    return api.post("/booking", payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  },
};

export default checkoutServices;
export interface CreateBookingLinkDto {
  referal_id: number;
  addOns: AddOnAddDto[];
  additionalInformation: string;
  units: number;
}

export interface Referral {
  id: number;
  item_id: number;
  referral_type: number;
  referral_time: string;
  additional_comments?: string;
  state: number;
  customer_name: any;
  customer_phone: any;
  customer_email: any;
  external_availability_id: number;
  fareharbor_customer_prototype_id: number;
  record_status: boolean;
  created_by: string;
  created_time: string;
  updated_by: any;
  updated_time: any;
  user: User;
  business: Business;
  item: Item;
  availability: any;
  requestToBook: any;
  selected_farehabor_availability: SelectedFarehaborAvailability;
}

export interface ProductOption {
  id: number;
  header: string;
  description: string;
  place_holder: string;
  type: number;
  required: boolean;
  availability: number;
  price: number;
  selectedValue: number;
  textValue: string;
}

export interface User {
  id: number;
  email: string;
  auth_type: number;
  password: string;
  first_name: string;
  last_name: string;
  avatar: string;
  role_id: number;
  stripe_id: string;
  external_token: string;
  created_by: string;
  created_time: string;
  updated_by: string;
  updated_time: string;
  record_status: boolean;
  email_verified: boolean;
  accepted_terms_and_conditions: boolean;
  work_place: any;
  business_users: any[];
}

export interface Business {
  id: number;
  business: string;
  business_description: string;
  business_users?: User[];
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipcode: string;
  country: any;
  phone: string;
  timezone: string;
  default_commission: any;
  stripe_id: string;
  farehabor_shortname: string;
  record_status: boolean;
  created_by: string;
  created_time: string;
  updated_by: string;
  updated_time: string;
  categories: Category[];
  industries: Industry[];
}

export interface Industry {
  id: number;
  industry: string;
  description: string;
  icon_uri: string;
}

export interface Item {
  id: number;
  item_type: number;
  commission: number;
  fareharbor_item_id: number;
  record_status: boolean;
  created_by: string;
  created_time: string;
  updated_by: string;
  updated_time: string;
  business: Business2;
  availabilities: any[];
  itemImages: any[];
  itemDetails: any[];
  additionalOptions: ProductOption[];
  industries: Industry3[];
  categories: Category3[];
  options: any[];
  availability?: any;
  requestToBook?: any;
  fareharbor_availabilities: FareharborAvailability[];
  farehabor_item_details: FarehaborItemDetails;
  min_age?: number;
  max_age?: number;
  max_guest?: number;
}

export interface Business2 {
  id: number;
  business: string;
  business_description: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipcode: string;
  country: any;
  phone: string;
  timezone: string;
  default_commission: any;
  stripe_id: string;
  farehabor_shortname: string;
  record_status: boolean;
  created_by: string;
  created_time: string;
  updated_by: string;
  updated_time: string;
  categories: Category2[];
  industries: Industry2[];
}

export interface Category2 {
  id: number;
  category: string;
  description: string;
  icon_uri: string;
}

export interface Industry2 {
  id: number;
  industry: string;
  description: string;
  icon_uri: string;
}

export interface Industry3 {
  id: number;
  industry: string;
  description: string;
  icon_uri: string;
}

export interface Category3 {
  id: number;
  category: string;
  description: string;
  icon_uri: string;
}

export interface FareharborAvailability {
  pk: number;
  start_at: string;
  end_at: string;
  capacity: number;
  minimum_party_size: number;
  maximum_party_size: any;
  online_booking_status: string;
  customer_type_rates: CustomerTypeRate2[];
  custom_field_instances: CustomFieldInstance[];
}

export interface CustomerTypeRate {
  pk: number;
  capacity: number;
  minimum_party_size: any;
  maximum_party_size: any;
  customer_type: CustomerType;
  customer_prototype: CustomerPrototype;
  custom_field_instances: CustomFieldInstance[];
}

export interface CustomerType {
  pk: number;
  singular: string;
  plural: string;
  note: string;
}

export interface CustomerPrototype {
  pk: number;
  display_name: string;
  note: string;
  total: number;
  total_including_tax: number;
}

export interface FarehaborItemDetails {
  pk: number;
  name: string;
  headline: string;
  primary_location: any;
  tax_percentage: number;
  booking_notes: string;
  booking_notes_safe_html: string;
  description: string;
  description_safe_html: string;
  description_text: string;
  description_bullets: any[];
  cancellation_policy: string;
  cancellation_policy_safe_html: string;
  location: string;
  locations: Location[];
  image_cdn_url: string;
  images: Image[];
  customer_prototypes: CustomerPrototype2[];
  is_pickup_ever_available: boolean;
  health_and_safety_policy: string;
  health_and_safety_policy_safe_html: string;
  effective_cancellation_policy: EffectiveCancellationPolicy;
  tags: any[];
  ratings: Ratings;
}

export interface Location {
  pk: number;
  type: string;
  note: string;
  note_safe_html: string;
  address: Address;
  longitude: number;
  latitude: number;
  google_place_id: string;
  tripadvisor_url: string;
}

export interface Address {
  street: string;
  city: string;
  province: string;
  country: string;
  postal_code: string;
}

export interface Image {
  pk: number;
  gallery: string;
  image_cdn_url: string;
  uri?: string;
}

export interface CustomerPrototype2 {
  pk: number;
  display_name: string;
  note: string;
  total: number;
  total_including_tax: number;
}

export interface EffectiveCancellationPolicy {
  type: string;
  cutoff_hours_before: number;
}

export interface Ratings {
  google_reviews: any;
  tripadvisor: any;
}

export interface SelectedFarehaborAvailability {
  pk: number;
  start_at: string;
  end_at: string;
  capacity: number;
  minimum_party_size: number;
  maximum_party_size: any;
  online_booking_status: string;
  customer_type_rates: CustomerTypeRate2[];
  item: Item2;
  headline: string;
  custom_field_instances: CustomFieldInstance[];
}

export interface CustomerTypeRate2 {
  pk: number;
  capacity: number;
  minimum_party_size: any;
  maximum_party_size: any;
  customer_type: CustomerType2;
  customer_prototype: CustomerPrototype3;
  total: number;
  total_including_tax: number;
  custom_field_instances: CustomFieldInstance[];
}

export interface CustomerType2 {
  pk: number;
  singular: string;
  plural: string;
  note: string;
}

export interface CustomerPrototype3 {
  pk: number;
  display_name: string;
  note: string;
  total: number;
  total_including_tax: number;
}

export interface Item2 {
  pk: number;
  name: string;
  headline: string;
  primary_location: any;
}

export interface CustomFieldInstance {
  pk: number;
  custom_field: CustomField;
  value_given?: any;
}

export interface CustomField {
  modifier_kind: string;
  modifier_type: string;
  offset: number;
  percentage: number;
  is_taxable: boolean;
  total: number;
  total_including_tax: number;
  is_always_per_customer: boolean;
  pk: number;
  type: string;
  is_required: boolean;
  description: string;
  description_safe_html: string;
  name: string;
  title: string;
  count_min: number;
  count_max: number;
  booking_notes: string;
  booking_notes_safe_html: string;
  extended_options: Array<ExtendedOptions>;
  value_given?: string;
}
export interface ExtendedOptions {
  modifier_kind: string;
  modifier_type: string;
  offset: number;
  percentage: number;
  is_taxable: boolean;
  total: number;
  total_including_tax: number;
  is_always_per_customer: boolean;
  pk: number;
  name: string;
  description: string;
  description_safe_html: string;
  is_selected: boolean;
}
export interface FareHarborBooking {
  custom_field_values: CustomFieldValue[];
  customers: Customer[];
  external_id: number; // Referral ID
  note: string;
  voucher_number: string;
  payment_info: Payment;
  total: number;
  payment_id: string;
}

export interface Contact {
  email: string;
  name: string;
  phone: string;
}

export interface CustomFieldValue {
  custom_field: number;
  value: any;
}

export interface Customer {
  customer_type_rate: number;
  customer_type_value: number;
}
export interface Payment {
  name: string;
  phone: string;
  email: string;
}
